import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { EstadoOrdenTrabajoCodigoEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';

const { put } = erpApi();

// visualizar tabla & upd orden_w - cierra orden_trabajo

///* tanSctack query
export const useRejectOTAuditoria = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: rejectOTAuditoria,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['ordenesTrabajo'] });

      if (res.status === 'success') {
        setAlert(true, 'Rechazo realizado con éxito', 'success');
      }

      return navigate(returnUrl, { replace: true });
    },
  });
};

export const useConfirmOTAuditoria = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: confirmOTAuditoria,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['ordenesTrabajo'] });

      if (res.status === 'success') {
        setAlert(true, 'Orden de trabajo confirmada con éxito', 'success');
      }

      return navigate(returnUrl, { replace: true });
    },
  });
};

///* axios
export type RechazoFormDataAuditoria = {
  estado: EstadoOrdenTrabajoCodigoEnum; // RECHAZADO_AUDITORIA
  user: number;
  motivo_rechazo_auditoria: string; // code
  usuario_rechazo_auditoria: number; // fk
  fecha_hora_rechazo_auditoria: string; // timestamp
};
export type RejectOTAuditoriaParams = {
  id: string;
  data: RechazoFormDataAuditoria;
};

export const rejectOTAuditoria = async ({
  data,
  id,
}: RejectOTAuditoriaParams) => {
  return put(`${urlBackend}api/v1/ordenes-trabajo/${id}/`, data, true);
};

export type ConfirmOTFormData = {
  estado: EstadoOrdenTrabajoCodigoEnum;
  user: number;
  user_auditoria: number;
  fecha_hora_user_auditoria?: string;
};
export type ConfirmOTParams = {
  id: string;
  data: ConfirmOTFormData;
};

export const confirmOTAuditoria = async ({ data, id }: ConfirmOTParams) => {
  return put(`${urlBackend}api/v1/ordenes-trabajo/${id}/`, data, true);
};
